import { setIsSessionInvalid, setIsSessionExpired } from "../slices/PaymentSessionDetailsSlice";

// Exposes window.__TEST_*__ helpers used to manually trigger error/crash
// screens during development. No-op in production.
export const registerDevTestHelpers = (dispatch) => {
  if (process.env.ENVIRONMENT === "PRODUCTION") return;

  window.__TEST_ERROR__ = () => {
    setTimeout(() => {
      throw new Error("TEST_GLOBAL_ERROR");
    });
  };

  window.__TEST_PROMISE_ERROR__ = () => {
    setTimeout(() => {
      Promise.reject(new Error("TEST_PROMISE_ERROR"));
    });
  };

  // simulates a cross-origin style error where browser sanitizes message/stack
  window.__TEST_CROSS_ORIGIN_ERROR__ = () => {
    window.dispatchEvent(new ErrorEvent("error", {
      bubbles: true,
      cancelable: true,
      message: "",
      error: null,
    }));
  };

  // simulates paymentSession.rejected to test the Technical Error screen
  window.__TEST_SESSION_REJECTED__ = () => {
    dispatch({
      type: "paymentSessionDetails/paymentSession/rejected",
      error: { message: "Network Error - simulated technical error" },
    });
  };

  // simulates technical error with a long stack trace to test email truncation
  window.__TEST_LONG_TECHNICAL_ERROR__ = () => {
    dispatch({
      type: "paymentSessionDetails/paymentSession/rejected",
      error: {
        message:
          `TypeError: Cannot read properties of undefined (reading 'paymentMethods')\n` +
          `    at processPaymentConfig (checkoutUtils.js:142:18)\n` +
          `    at initializeCheckout (BoxPayCheckout.jsx:87:12)\n` +
          `    at renderWithHooks (react-dom.development.js:14985:18)\n` +
          `    at mountIndeterminateComponent (react-dom.development.js:17811:13)\n` +
          `    at beginWork (react-dom.development.js:19049:16)\n` +
          `    at HTMLUnknownElement.callCallback (react-dom.development.js:3990:14)\n` +
          `    at invokeGuardedCallbackDev (react-dom.development.js:4039:16)\n` +
          `    at invokeGuardedCallback (react-dom.development.js:4096:31)\n` +
          `    at beginWork$1 (react-dom.development.js:23959:7)\n` +
          `    at performUnitOfWork (react-dom.development.js:22776:12)\n` +
          `    at workLoopSync (react-dom.development.js:22707:5)\n` +
          `    at renderRootSync (react-dom.development.js:22670:7)\n` +
          `    at performSyncWorkOnRoot (react-dom.development.js:22293:20)\n` +
          `    at scheduleUpdateOnFiber (react-dom.development.js:21881:7)\n` +
          `    at dispatchAction (react-dom.development.js:16139:7)\n` +
          `    at PaymentOptions.jsx:204:14\n` +
          `    at processPaymentMethodsList (PaymentOptions.jsx:198:5)\n` +
          `    at BoxPayCheckout.jsx:312:18\n` +
          `    at commitHookEffectListMount (react-dom.development.js:23150:26)`,
      },
    });
  };

  // simulates invalid session screen
  window.__TEST_INVALID_SESSION__ = () => {
    dispatch(setIsSessionInvalid(true));
  };

  // simulates expired session screen
  window.__TEST_EXPIRED_SESSION__ = () => {
    dispatch(setIsSessionExpired(true));
  };
};
